import { API_CALL } from '../middleware/api';

export const GET_CARE_UPDATES = 'access/get-care-updates';
export const GET_CARE_UPDATES_RESULT = `${GET_CARE_UPDATES}/result`;
export const CREATE_CARE_ESCALATION = 'access/create-care-escalation';
export const CREATE_CARE_ESCALATION_RESULT = `${CREATE_CARE_ESCALATION}/result`;
export const EDIT_CARE_UPDATE = 'access/edit-care-update';
export const EDIT_CARE_UPDATE_RESULT = `${EDIT_CARE_UPDATE}/result`;
export const PREVIEW_CARE_UPDATE = 'access/preview-care-update';
export const PREVIEW_CARE_UPDATE_RESULT = `${PREVIEW_CARE_UPDATE}/result`;

const endpoint = enrollmentId => `portal/cmmi-access/enrollment/${encodeURIComponent(enrollmentId)}/care-updates`;

export const careUpdateActions = {
  preview: (enrollmentId, updateId) => ({
    [API_CALL]: { method: 'GET', endpoint: `${endpoint(enrollmentId)}/${encodeURIComponent(updateId)}/pdf`, responseType: 'blob' },
    type: PREVIEW_CARE_UPDATE,
  }),
  list: enrollmentId => ({
    [API_CALL]: { method: 'GET', endpoint: endpoint(enrollmentId) },
    type: GET_CARE_UPDATES,
  }),
  createEscalation: enrollmentId => ({
    [API_CALL]: { method: 'POST', endpoint: `${endpoint(enrollmentId)}/escalation`, data: {} },
    type: CREATE_CARE_ESCALATION,
  }),
  edit: (enrollmentId, updateId, data) => ({
    [API_CALL]: { method: 'PATCH', endpoint: `${endpoint(enrollmentId)}/${encodeURIComponent(updateId)}`, data },
    type: EDIT_CARE_UPDATE,
  }),
};
